import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProfileTile } from "@/pages/Dashboard";

export default function Shortlist() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/shortlist").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div className="container-px py-8">
      <span className="label-cap">Saved</span>
      <h1 className="font-heading text-4xl text-primary mt-1 mb-6">My shortlist</h1>
      {items.length === 0 ? (
        <div className="text-center py-16 border border-dashed rounded-2xl text-muted-foreground">No saved profiles yet. Tap the sparkle icon on profiles you like.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => <ProfileTile key={p.user_id} p={p} />)}
        </div>
      )}
    </div>
  );
}
